import React from "react";
// * React router dom stuff
import { Switch, Route } from "react-router-dom";
import { routes } from "routes/MainPage";
// * Components
import { Navbar, Loader, Footer, ScrollToTop } from "components";
import { LoaderContainer } from "utils";
export const MainPageRouter = ({}) => {
  return (
    <div className="home__router">
      <Navbar />
      <ScrollToTop />
      <React.Suspense
        fallback={
          <LoaderContainer>
            <Loader />
          </LoaderContainer>
        }
      >
        <Switch>
          {routes.map((route, index) => (
            <Route
              index={route.isIndex}
              key={index}
              path={route.path}
              exact={route.exact}
              render={(props) => <route.component {...props} />}
            />
          ))}
        </Switch>
      </React.Suspense>
      <Footer />
    </div>
  );
};
